/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 19,
  image: "",
  title: "Changelog Notes - V3.3.0-beta",
  shortDescription: "We have released some significant features and improvements to our platform. We have integrated Solana and Avalanche chains for payment. We have released password protected domain that will encrypt the onchain deployments. We have also introduced our intercom chatbot to help our users quickly. We have also fixed some major bugs and improved our existing features.",
  description: "In this version, we have released some significant features and improvements to our platform. We have integrated Solana and Avalanche chains for payment and released a brand-new feature to help many developers. We have released password protected domain that will encrypt the onchain deployment so that others can't access the site even though they know the website hash. Only those who have access to the password can access the website. We have also introduced our intercom chatbot to help our users quickly. We have also fixed some major bugs and improved our existing features.",
  date: "Jan 8th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Avalanche", "Bonus", "CD", "solana", "bug", "fixes", "Spheron IPFS Gateway", "Instance", "infrastructure", "Sui", "Compute"]
};
export const content = ` 
## Introducing Solana Chain

<div className="image-box-shadow">
  <img
    src="/changelog/v3.3.0/solana.png"
    alt="Solana chain "
    className="rounded-[12px]"
  />
</div>

We have introduced the option to make payments with the **Solana** chain. To pay for the Spheron plan with Solana chain, you will need to connect
the **Phantom wallet** to our app on the Billing page. Right now, we only support payment of **Solana Native Token**. We will add more tokens in
the future. Payments via Solana do not require users to give allowance or deposit to a contract. Instead, we transfer directly from your wallet to
Spheron Cold wallets. If you lost your fund for some technical reason and transferred funds you don't intend to, you can reach out to Spheron
Team for quick resolutions.

## Introducing Avalanche Chain

<div className="image-box-shadow">
  <img
    src="/changelog/v3.3.0/avalanche.png"
    alt="avalanche "
    className="rounded-[12px]"
  />
</div>

We have introduced the **Avalanche Chain** for subscription payments and have allowed four tokens - **USDT, USDC, DAI,** and **WAVAX** - on the
chain. To upgrade to the PRO plan, users can connect their MetaMask wallet and select the **Avalanche Chain** option to upgrade to the
subscription plan and purchase bonuses.

## Introducing Sui Node in the Marketplace

<div className="image-box-shadow">
  <img src="/changelog/v3.3.0/sui.png" alt="sui " className="rounded-[12px]" />
</div>

We have added the Sui Devnet node in the compute marketplace. You can now spin up a Sui Devnet node with Spheron compute infrastructure
at a cost-effective plan. Sui is the first permissionless Layer 1 blockchain designed from the ground up to enable creators and developers to build
experiences that cater to the next billion users in web3. With Spheron compute, you can spin up your Sui Devnet node in the decentralized cloud
within minutes. We want you to experience the difference. This is the platform where you can finally say goodbye to centralized servers and the
fear of losing everything within minutes.

We offer you another option to spin your nodes and scale with minimal technical knowledge. We make it easy for you to monitor your nodes and
notify you when they are down. We dedicate a private instance and an IP to your Sui Devnet node, improving its security and performance.

Ready to spin your next Sui Devnet node? See how you can spin and manage your Sui Devnet node on dCloud in seconds with Spheron
powered by Akash Network. You can access the best of both worlds, cloud and dedicated decentralized servers.

## Password Protected Deployments

<div className="image-box-shadow">
  <img
    src="/changelog/v3.3.0/password.png"
    alt="Password protection "
    className="rounded-[12px]"
  />
</div>

We have added a password protection option for deployments and domains on Spheron.

When accessing the content on IPFS or Arweave, it will be fully encrypted and unreadable to anyone without the correct secret. However, when
accessing the content through your domains and subdomains, including the spheron domain provided by default, the platform will decrypt the
content for you upon entering the correct secret. This feature allows you to secure your deployments with a password and encryption, ensuring
that only you and those you trust can access the content.

Once enabled for your organization, this feature can be applied to any of your projects by redeploying. If you have any questions or need
assistance getting started with this feature, please let us know, and we will be happy to help.

## Intercom Integration

Our team has integrated the Intercom chatbot into the Spheron app to provide a quick and easy way for you to get in touch with us. You will also
be able to check out guides and articles personalized by our automated chatbot. If you have any questions or need assistance, send us a
message through the app, and we'll do our best to get back to you as soon as possible.

## Improvements

- **Project environment variables:** When starting a new deployment, any new specified environment variables that do not already exist will be
  added to the project settings.

- **Commit and PR comments:** From now on, comments on your repository PRs and commits will include a list of the domains that were
  updated by the deployment.

- **Compute PRO plan:** Instead of receiving a fixed amount of 50 AKT, the PRO subscription plan will now provide 10$ worth of AKT

- **Git provider user new user accounts:** We have added a restriction that requires your Git provider user account to be at least 30 days old to
  access the Spheron app. If you have a newer account, please contact us to get access.

- **Organization and Project IDs:** Organization and project IDs are now available on their respective settings pages, making it easier to locate
  and use with your API token.

## Fixes 🛠

- **Logs of redeployed deployment:** We have fixed the issue that was causing the logs of the deployment that is being redeployed to show on
  the new deployment.

- **Hugo framework configured with npm:** We have made the changes to enable the deployment of Hugo applications that are set up using
  npm.

- **Static framework publish directory :** We have fixed the issue so that only files from the publish directory are uploaded when the static
  framework is selected.

- **HNS domain validation:** We have fixed the validation of HNS domain names

- **Broken domain link:** We have fixed the broken link on all the domain pages of the project

- **UX Issues across the app:**
  - We fixed the issue where empty rows appeared in the cluster domain dropdown.
  - We have fixed the issue where the unit price was not displayed for new member payments.
  - We have addressed the issue of slow uploads for organization and user avatar images. This should no longer be a problem
    `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
